import { callApi } from "repoV2/utils/common/api/callApi";
import { CALL_API_METHODS } from "repoV2/constants/apis";
import { listing_apis } from "../Listing.constants";
import { IListing } from "../Listing.interfaces";

export const callGetUpsellListingsApi = async ({
    listingUuid,
    upsellType,
    dynamicLinkUuid,
}: {
    listingUuid: string;
    upsellType: number;
    dynamicLinkUuid?: string;
}): Promise<{ data: IListing.IGetUpsellListingsApiResponse }> =>
    callApi({
        url: `${listing_apis.get_upsell_listings}/${listingUuid}`,
        method: CALL_API_METHODS.GET,
        params: {
            upsell_type: upsellType,
            ...(dynamicLinkUuid && {
                dynamic_link_id: dynamicLinkUuid,
            }),
        },
        extraOptions: {
            appendExlyBackendHeaders: true,
        },
    });
